<template>
  <div class="promotionPlan">
    <menu-list></menu-list>
    <div class="varietyContianer">
        <div class="promotionVariety" :key="index" v-for="(item,index) in promotionVariety" @click="navigate(item)">
            <div class="contentLeft">
                <img :src="item.imgUrl" alt="">
            </div>
            <div class="contentRight">
                <div class="textContent">
                    <span class="contentTitle" :style="'color:'+item.titleColor">{{item.title}}</span>
                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import menuList from '../../../components/business/menuList.vue'
export default {
  components: { menuList },
  data(){
    return{
        promotionVariety:[
          {
            id:'timelimit',//充当menuIdmemuList所需
            imgUrl:'/static/timelimit.png',
            title:'限时特价',
            name:'限时特价',//memuList所需
            content:'设置限时特价商品',
            titleColor:'#458cff',
            url:'/promotion/timedSpecials'//memuList所需
          },
          {
            id:'tilimitDiscount',
            imgUrl:'/static/tilimitDiscount.png',
            title:'限时折扣',
            name:'限时折扣',
            content:'设置限时打折促销的商品',
            titleColor:'#458cff',
            url:'/promotion/tilimitDiscount'
          },
          {
            id:'fullReduction',
            imgUrl:'/static/fullReduction.png',
            title:'满减活动',
            name:'满减活动',
            content:'购买一定金额享受优惠',
            titleColor:'#458cff',
            url:'/promotion/fullReduction'
          },
          {
            id:'fullDiscount',
            imgUrl:'/static/fullDiscount.png',
            title:'满减折扣',
            name:'满减折扣',
            content:'购买一定数量享受优惠',
            titleColor:'#458cff',
            url:'/promotion/fullDiscount'
          },
        ]
    }
  },
  created(){
    this.refontSize();
  },
  methods:{
    refontSize() {
      document.documentElement.style.fontSize =
        (document.documentElement.clientWidth / 1920) * 10 + "px";
    },
    navigate(menu){
      this.$utils.setBread(menu,this)
    }
  }

}
</script>

<style scoped>
.promotionPlan{
}

.varietyContianer{
    display: flex;
    flex-flow: row nowrap;
    padding: 15px;
}
.promotionVariety{
  width: 18%;
  margin-right:10px;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  cursor: pointer;
}
.promotionVariety .contentLeft{
  width: 46px;
  display: flex;
  align-items: center;
}
.promotionVariety .contentLeft img{
  width:46px;
  height:46px;
}
.promotionVariety .contentRight{
    width: 100%;
    display: flex;
    align-items: center;
}
.promotionVariety .contentRight .textContent{
    font-size: 1.4rem;
    color: #999999;
    margin-left: 5px;
}
.promotionVariety .contentRight .textContent .contentTitle{
    font-size: 1.6rem;
}
</style>


// WEBPACK FOOTER //
// src/page/promotion/promotionTool/Plan.vue